export default __webpack_public_path__ + "static/media/add2.a030dfc3.png";